import React, { Component } from 'react';
import { _fetch } from './_fetch';
import { Spinner } from 'reactstrap';
import TextInput from './TextInput';
import { customFunctions } from './CustomFunctions.js';
import Popup from './modal';
import Toast from './toast.js';
import { format } from 'date-fns';

export class LoanApplicationStep3 extends Component {
    static displayName = LoanApplicationStep3.name;
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            countries: [],
            states: [],
            showModal: false,
            ButtonText: 'Next',
            ContinueToken: '',
            emailValid: false
        }
    }

    componentDidMount() {
        try {
            var id = localStorage.getItem("CONTINUE_TOKEN");

            this.setState({ loading: true });

            if (id != null) this.setState({ ContinueToken: id });

            var fetch = _fetch();

            fetch.get("/creditapplicationpublic/getcountriesPublic")
                .then((data) => {
                    this.setState({ countries: data });
                });

            fetch.get("/creditapplicationpublic/getstatesPublic")
                .then((data) => {
                    this.setState({ states: data, loading: false });
                    if (id != null) this.loadPage(id);
                });
        }
        catch (err) {
            this.setState({ loading: false });
            console.log('componentDidMount - ' + err);
        }
    }

    loadPage(id) {
        try {
            this.setState({ loading: true });
            var fetch = _fetch();
            fetch.get("/creditapplicationpublic/GetCreditApplicationStep3Public?id=" + id)
                .then((data) => {
                    var _state = this.state;
                    for (const key in data) {
                        if (data[key] != null) {
                            var _key = key.charAt(0).toUpperCase() + key.slice(1);
                            var _value = data[key];
                            _state[_key] = _value;
                        }
                    }
                    this.setState(_state,
                        function () {
                            this.setState({ loading: false });
                            this.calculateTotal();
                            this.setState({ emailValid: customFunctions.validateEmail(this.state.CoBorrowerEmail ?? "") });
                            this.setState({
                                CoBorrowerDOB: this.sqlToJsDate(this.state.CoBorrowerDOB),
                                BorrowerSignatureDate: this.sqlToJsDate(this.state.BorrowerSignatureDate),
                                CoBorrowerSignatureDate: this.sqlToJsDate(this.state.CoBorrowerSignatureDate)
                            });
                        });
                });
        }
        catch (err) {
            this.setState({ loading: false });
            console.log('loadPage - ' + err);
        }
    }

    calculateTotal() {
        var s = this.state;
        var coBorrowerIncomeWages = this.zeroOrValue(s.CoBorrowerIncomeWages);
        var coBorrowerIncomeDistributions = this.zeroOrValue(s.CoBorrowerIncomeDistributions);
        var coBorrowerIncomeRentalIncome = this.zeroOrValue(s.CoBorrowerIncomeRentalIncome);
        var coBorrowerIncomePension = this.zeroOrValue(s.CoBorrowerIncomePension);
        var coBorrowerIncomeOther = this.zeroOrValue(s.CoBorrowerIncomeOther);

        var coBorrowerIncomeTotal = coBorrowerIncomeWages + coBorrowerIncomeDistributions + coBorrowerIncomeRentalIncome + coBorrowerIncomePension + coBorrowerIncomeOther;

        var totalRaw = this.formatCurrency(coBorrowerIncomeTotal);

        if (totalRaw && totalRaw.startsWith('$') && !totalRaw.includes('.')) {
            totalRaw = totalRaw + '.00';
        }
        else if (totalRaw.startsWith('$') && totalRaw.includes('.')) {
            var spl = totalRaw.split(".");
            if (spl[1].length == 0) {
                totalRaw = totalRaw + '00';
            }

            if (spl[1].length == 1) {
                totalRaw = totalRaw + '0';
            }
        }
        this.setState({ CoBorrowerIncomeTotal: totalRaw });
    }

    zeroOrValue(value) {
        if (value == undefined || value == 0 || value == null) return 0;
        //if (isNaN(value)) {
        //    value = value.toString().substring(1, value.toString().lenth - 1);
        //}
        var _value = value?.toString().replace(/,/g, '').replace('$', '');

        if (_value.length > 0) {

            var result = (isNaN(_value) || _value == undefined) ? 0 : parseFloat(_value);
            return result;
        }
        else {
            return 0;
        }
    }

    formatCurrency(value) {
        if (value == undefined) return "";
        var _values = value.toString().replace(/,/g, '').replace('$', '');

        var dec = "";
        var _value = "";

        var elements = _values.split('.');
        if (elements?.length == 1) {
            _value = _values.split('.')[0];
        }
        else if (elements?.length > 1) {
            _value = _values.split('.')[0];
            dec = "." + _values.split('.')[1].substring(0, 2);
        }
        else {
            _value = _values;
        }
        if (_value.length > 0) {
            return new Intl.NumberFormat(undefined, {
                style: 'currency',
                currency: 'USD',
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
            }).format(_value) + dec;
        }
    }

    save(url) {
        try {
            var item = [];

            if (url === undefined) {
                if (this.state.CoBorrowerFirstName == undefined || this.state.CoBorrowerFirstName?.length == 0) {
                    item.push("First Name");
                }
                if (this.state.CoBorrowerLastName == undefined || this.state.CoBorrowerLastName?.length == 0) {
                    item.push("Last Name");
                }
                if (this.state.CoBorrowerSSN == undefined || this.state.CoBorrowerSSN?.length == 0) {
                    item.push("SSN");
                }
                if (this.state.CoBorrowerSSN?.length < 11) {
                    item.push("Invalid SSN");
                }
                if (this.state.CoBorrowerDOB == undefined || this.state.CoBorrowerDOB?.length == 0) {
                    item.push("Date of Birth");
                }
                if (this.state.CoBorrowerUSCitizen === undefined) {
                    item.push("US Citizen");
                }
                if (this.state.CoBorrowerUSCitizen !== undefined && this.state.CoBorrowerUSCitizen === "No" && this.state.CoBorrowerUSCitizenCountry === 0) {
                    item.push("Non US Citizen Country");
                }
                if ((this.state.CoBorrowerCellPhone === undefined || this.state.CoBorrowerCellPhone?.length === 0) &&
                    (this.state.CoBorrowerOtherPhone === undefined || this.state.CoBorrowerOtherPhone?.length === 0)) {
                    item.push("Cell Phone or Other Phone");
                }
                if ((this.state.CoBorrowerCellPhone?.length < 10 && this.state.CoBorrowerCellPhone?.length > 0) ||
                    (this.state.CoBorrowerOtherPhone?.length < 10 && this.state.CoBorrowerOtherPhone?.length > 0)) {
                    item.push("Cell Phone or Other Phone");
                }
                if (this.state.CoBorrowerEmail == undefined || this.state.CoBorrowerEmail?.length == 0) {
                    item.push("Email");
                }
                if (!this.state.emailValid) {
                    item.push("Invalid Email");
                }
                if (this.state.BorrowerSignature == undefined || this.state.BorrowerSignature?.length == 0) {
                    item.push("Borrower Signature");
                }
                if (this.state.BorrowerSignatureDate == undefined || this.state.BorrowerSignatureDate?.length == 0) {
                    item.push("Borrower Signature Date");
                }
                if (this.state.CoBorrowerSignature == undefined || this.state.CoBorrowerSignature?.length == 0) {
                    item.push("CoBorrower Signature");
                }
                if (this.state.CoBorrowerSignatureDate == undefined || this.state.CoBorrowerSignatureDate?.length == 0) {
                    item.push("CoBorrower Signature Date");
                }
            }
            if (item.length == 0) {
                this.setState({ loading: true });
                var fetch = _fetch();
                //this.setState({
                //    CoBorrowerDOB: this.state.CoBorrowerDOB === undefined || this.state.CoBorrowerDOB == "" ? null : format(new Date(this.state.CoBorrowerDOB.replace(/-/g, '/')), "yyyy-MM-dd"),
                //    BorrowerSignatureDate: this.state.BorrowerSignatureDate === undefined || this.state.BorrowerSignatureDate == "" ? null : format(new Date(this.state.BorrowerSignatureDate.replace(/-/g, '/')), "yyyy-MM-dd"),
                //    CoBorrowerSignatureDate: this.state.CoBorrowerSignatureDate === undefined || this.state.CoBorrowerSignatureDate == "" ? null : format(new Date(this.state.CoBorrowerSignatureDate.replace(/-/g, '/')), "yyyy-MM-dd")
                //},
                //    function () {
                fetch.post("/creditapplicationpublic/SaveCreditApplicationStep3Public", this.state)
                    .then((id) => {
                        if (id) {
                            if (url === undefined) {
                                this.setState({ loading: false });
                                this.setState({ showModal: true });
                            }
                            else {
                                window.location.href = url;
                            }
                        }
                        else {
                            this.setState({
                                showToast: true,
                                toastMessage: 'There was an issue saving your information. Please try again',
                                loading: false
                            });
                        }
                    })
                //});
            }
            else {
                this.setState({
                    showToast: true,
                    toastMessage: 'The following fields are required:',
                    toastItems: item
                });
                setTimeout(function () { document.getElementById("maincontainer").scrollTo({ top: 0, behavior: 'smooth' }); }, 250);
            }
        }
        catch (err) {
            this.setState({ loading: false });
            console.log('save - ' + err);
        }
    }

    sqlToJsDate(sqlDate) {
        if (sqlDate == "" || sqlDate === undefined) return sqlDate;

        var dateParts = sqlDate.split("T");
        return dateParts[0];
    }

    lastNameOnBlur() {
        let s = this.state;
        var f = s.CoBorrowerFirstName == undefined ? "" : s.CoBorrowerFirstName.toString() + " ";
        var m = s.CoBorrowerMiddleInitial == undefined ? "" : s.CoBorrowerMiddleInitial.toString() + " ";
        var l = s.CoBorrowerLastName == undefined ? "" : s.CoBorrowerLastName?.toString();
        var sig = f + m + l;

        //this.setState({ CoBorrowerSignature: sig });
        sessionStorage.setItem("CoBorrowerSignature", sig);
    }

    loadBorrowerAddress() {
        var id = localStorage.getItem("CONTINUE_TOKEN");

        var fetch = _fetch();
        fetch.get("/creditapplicationpublic/GetCreditApplicationStep2Public?id=" + id)
            .then((data) => {
                this.setState({
                    CoBorrowerCurrentAddress: data.borrowerCurrentAddress,
                    CoBorrowerCurrentCity: data.borrowerCurrentCity,
                    CoBorrowerCurrentStateId: data.borrowerCurrentStateId,
                    CoBorrowerCurrentZip: data.borrowerCurrentZip,
                    CoBorrowerCurrentYears: data.borrowerCurrentYears

                });
            });
    }

    render() {
        return (
            <div className="container-top">
                <div id="maincontainer" className="container-for-fixed-header">
                    {this.state.loading === true ?
                        <div>
                            <Spinner color="#000" children='' style={{ position: 'fixed', top: '50%', left: '50%' }} />
                        </div>
                        : null
                    }
                    <Toast
                        toastText={this.state.toastMessage}
                        listItems={this.state.toastItems}
                        showToast={this.state.showToast}
                        onToastClose={() => this.setState({ showToast: false })}
                        autoHideToastDelay={10000}
                    />
                    <table cellSpacing={2} cellPadding={2}>
                        <tbody>
                            <tr>
                                <td align="left" colSpan={2}>
                                    <label style={{ fontSize: '22px', fontWeight: '500', color: '#596db3' }}>Co-Borrower Information</label>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <table cellPadding={2} cellSpacing={2}>
                                        <tbody>
                                            <tr>
                                                <td align="left" valign="bottom">
                                                    <TextInput
                                                        Type="text"
                                                        Label="First Name"
                                                        TextChanged={(e) => {
                                                            this.setState({ CoBorrowerFirstName: e },
                                                                function () {
                                                                    this.lastNameOnBlur();
                                                                });
                                                        }}
                                                        Value={this.state.CoBorrowerFirstName ?? ""}
                                                        Style={{ width: '11vw' }}
                                                    />
                                                </td>
                                                <td align="left" valign="bottom">
                                                    <TextInput
                                                        Type="text"
                                                        Label="M.I"
                                                        MaxTextLength={1}
                                                        TextChanged={(e) => {
                                                            this.setState({ CoBorrowerMiddleInitial: e },
                                                                function () {
                                                                    this.lastNameOnBlur();
                                                                });
                                                        }}
                                                        Value={this.state.CoBorrowerMiddleInitial ?? ""}
                                                        Style={{ width: '7vw' }}
                                                    />
                                                </td>
                                                <td align="left" valign="bottom">
                                                    <TextInput
                                                        Type="text"
                                                        Label="Last Name"
                                                        TextChanged={(e) => {
                                                            this.setState({ CoBorrowerLastName: e },
                                                                function () {
                                                                    this.lastNameOnBlur();
                                                                });
                                                        }}
                                                        Value={this.state.CoBorrowerLastName ?? ""}
                                                        Style={{ width: '11vw' }}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <table cellPadding={2} cellSpacing={2}>
                                        <tbody>
                                            <tr>
                                                <td align="left" valign="bottom">
                                                    <TextInput
                                                        Type="ssn"
                                                        Label="SSN"
                                                        MaxTextLength={11}
                                                        TextChanged={(e) => {
                                                            var formattedSSN = customFunctions.formatSocialSecurity(e);
                                                            this.setState({ CoBorrowerSSN: formattedSSN });
                                                        }}
                                                        Value={customFunctions.formatSocialSecurity(this.state.CoBorrowerSSN) ?? ""}
                                                        Style={{ width: '11vw' }}
                                                    />
                                                </td>
                                                <td align="left" valign="bottom">
                                                    <TextInput
                                                        Type="date"
                                                        Label="Date of Birth"
                                                        TextChanged={(e) => {
                                                            this.setState({ CoBorrowerDOB: e });
                                                        }}
                                                        Value={this.state.CoBorrowerDOB != undefined ? this.sqlToJsDate(this.state.CoBorrowerDOB) : ""}
                                                        Style={{ width: '7vw' }}
                                                    />
                                                </td>
                                                <td align="left" valign="bottom">
                                                    <TextInput
                                                        Type="text"
                                                        Label="Relationship to Applicant"
                                                        MaxTextLength={50}
                                                        TextChanged={(e) => {
                                                            this.setState({ RelationshipToApplicant: e });
                                                        }}
                                                        Value={this.state.RelationshipToApplicant ?? ""}
                                                        Style={{ width: '11vw' }}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <table cellPadding={2} cellSpacing={2}>
                                        <tbody>
                                            <tr>
                                                <td align="left" valign="middle">
                                                    US citizen?
                                                </td>
                                                <td align="left" valign="middle">
                                                    <div className="radioGroup">
                                                        <input type="radio"
                                                            name="country"
                                                            style={{ marginRight: '5px' }}
                                                            onChange={(e) => {
                                                                this.setState({ CoBorrowerUSCitizen: e.target.checked ? "Yes" : "No" });
                                                            }}
                                                            checked={this.state.CoBorrowerUSCitizen === "Yes"}
                                                        ></input>
                                                        <label>Yes</label>
                                                        <input type="radio"
                                                            name="country"
                                                            style={{ marginRight: '5px' }}
                                                            onChange={(e) => {
                                                                this.setState({ CoBorrowerUSCitizen: e.target.checked ? "No" : "Yes" });
                                                            }}
                                                            checked={this.state.CoBorrowerUSCitizen === "No"}
                                                        ></input>
                                                        <label>No</label>
                                                        {this.state.CoBorrowerUSCitizen === "No" ?
                                                            <select
                                                                value={this.state.CoBorrowerUSCitizenCountry}
                                                                onChange={(e) => {
                                                                    this.setState({ CoBorrowerUSCitizenCountry: e.target.value })
                                                                }}
                                                            >
                                                                <option key={0} value={0}>Select a Country</option>
                                                                {this.state.countries.map((item, idx) =>
                                                                    <option key={idx} value={item.name}>{item.name}</option>
                                                                )}
                                                            </select>
                                                            : null}
                                                    </div>
                                                </td>
                                                <td>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <table cellPadding={2} cellSpacing={2}>
                                        <tbody>
                                            <tr>
                                                <td align="left" valign="bottom">
                                                    <TextInput
                                                        Type="phone"
                                                        Label="Cell Phone"
                                                        MaxTextLength={14}
                                                        TextChanged={(e) => {
                                                            var formattedPhone = customFunctions.formatPhoneNumber(e);
                                                            this.setState({ CoBorrowerCellPhone: formattedPhone });
                                                        }}
                                                        Value={customFunctions.formatPhoneNumber(this.state.CoBorrowerCellPhone) ?? ""}
                                                        Style={{ width: '10vw' }}
                                                    />
                                                </td>
                                                <td align="left" valign="bottom">
                                                    <TextInput
                                                        Type="phone"
                                                        Label="Other Phone"
                                                        MaxTextLength={14}
                                                        TextChanged={(e) => {
                                                            var formattedPhone = customFunctions.formatPhoneNumber(e);
                                                            this.setState({ CoBorrowerOtherPhone: formattedPhone });
                                                        }}
                                                        Value={customFunctions.formatPhoneNumber(this.state.CoBorrowerOtherPhone) ?? ""}
                                                        Style={{ width: '10vw' }}
                                                    />
                                                </td>
                                                <td>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <table cellPadding={2} cellSpacing={2}>
                                        <tbody>
                                            <tr>
                                                <td colSpan={2} align="left" valign="bottom">
                                                    <TextInput
                                                        Type="email"
                                                        Label="Email"
                                                        TextChanged={(e) => {
                                                            this.setState({ emailValid: customFunctions.validateEmail(e) });
                                                            this.setState({ CoBorrowerEmail: e });
                                                        }}
                                                        Value={this.state.CoBorrowerEmail ?? ""}
                                                        Style={{ width: '20.2vw' }}
                                                    />
                                                </td>
                                                <td>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table>
                        <tbody>
                            <tr>
                                <td align="left" style={{ paddingRight: '3vw' }} >
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td style={{
                                                    fontSize: '15px', fontWeight: '500', paddingTop: '15px', display: 'flex',
                                                    flexDirection: 'row', alignItems: 'center'
                                                }} align="left">
                                                    <label style={{ fontSize: '14px' }}>Current Residence</label>
                                                    <button
                                                        className="creditAppNext"
                                                        style={{ whiteSpace: 'nowrap', marginLeft: '8px', fontSize: '.52vw', height: '22px', display: 'flex', alignItems: 'center' }}
                                                        disabled={this.state.loading ? true : false}
                                                        onClick={() => {
                                                            this.loadBorrowerAddress();
                                                        }}
                                                        disabled={this.state.loading}
                                                    >
                                                        Copy Borrower's Address
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <table cellPadding={2} cellSpacing={2}>
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan={3} align="left" valign="bottom">
                                                                    <TextInput
                                                                        Type="text"
                                                                        Label="Home Address"
                                                                        TextChanged={(e) => {
                                                                            this.setState({ CoBorrowerCurrentAddress: e });
                                                                        }}
                                                                        Value={this.state.CoBorrowerCurrentAddress ?? ""}
                                                                        Style={{ width: '16vw' }}
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td align="left" valign="bottom">
                                                                    <TextInput
                                                                        Type="text"
                                                                        Label="City"
                                                                        TextChanged={(e) => {
                                                                            this.setState({ CoBorrowerCurrentCity: e });
                                                                        }}
                                                                        Value={this.state.CoBorrowerCurrentCity ?? ""}
                                                                        Style={{ width: '5vw' }}
                                                                    />
                                                                </td>
                                                                <td align="left" valign="bottom">
                                                                    <select
                                                                        value={this.state.CoBorrowerCurrentStateId}
                                                                        onChange={(e) => {
                                                                            this.setState({ CoBorrowerCurrentStateId: e.target.value })
                                                                        }}
                                                                    >
                                                                        <option key={0} value={0}>--</option>
                                                                        {this.state.states.map((item, idx) =>
                                                                            <option key={idx} value={item.id}>{item.name}</option>
                                                                        )}
                                                                    </select>
                                                                </td>
                                                                <td align="left" valign="bottom">
                                                                    <TextInput
                                                                        Type="number"
                                                                        MaxTextLength={5}
                                                                        Label="Zip"
                                                                        TextChanged={(e) => {
                                                                            this.setState({ CoBorrowerCurrentZip: e });
                                                                        }}
                                                                        Value={this.state.CoBorrowerCurrentZip ?? ""}
                                                                        Style={{ width: '5vw' }}
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td align="left" valign="bottom">
                                                                    <TextInput
                                                                        Type="number"
                                                                        Label="# Years"
                                                                        min={1}
                                                                        max={99}
                                                                        MaxTextLength={2}
                                                                        TextChanged={(e) => {
                                                                            this.setState({ CoBorrowerCurrentYears: e });
                                                                        }}
                                                                        Value={this.state.CoBorrowerCurrentYears ?? ""}
                                                                        Style={{ width: '5vw' }}
                                                                    />
                                                                </td>
                                                                <td>
                                                                </td>
                                                                <td>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                                <td align="left">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td colSpan={3} style={{ fontSize: '15px', fontWeight: '500', paddingTop: '15px' }} align="left">
                                                    Previous Residence
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <table cellPadding={2} cellSpacing={2}>
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan={3} align="left" valign="bottom">
                                                                    <TextInput
                                                                        Type="text"
                                                                        Label="Home Address"
                                                                        TextChanged={(e) => {
                                                                            this.setState({ CoBorrowerPreviousAddress: e });
                                                                        }}
                                                                        Value={this.state.CoBorrowerPreviousAddress ?? ""}
                                                                        Style={{ width: '16vw' }}
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td align="left" valign="bottom">
                                                                    <TextInput
                                                                        Type="text"
                                                                        Label="City"
                                                                        TextChanged={(e) => {
                                                                            this.setState({ CoBorrowerPreviousCity: e });
                                                                        }}
                                                                        Value={this.state.CoBorrowerPreviousCity ?? ""}
                                                                        Style={{ width: '5vw' }}
                                                                    />
                                                                </td>
                                                                <td align="left" valign="bottom">
                                                                    <select
                                                                        value={this.state.CoBorrowerPreviousStateId}
                                                                        onChange={(e) => {
                                                                            this.setState({ CoBorrowerPreviousStateId: e.target.value })
                                                                        }}
                                                                    >
                                                                        <option key={0} value={0}>--</option>
                                                                        {this.state.states.map((item, idx) =>
                                                                            <option key={idx} value={item.id}>{item.name}</option>
                                                                        )}
                                                                    </select>
                                                                </td>
                                                                <td align="left" valign="bottom">
                                                                    <TextInput
                                                                        Type="number"
                                                                        MaxTextLength={5}
                                                                        Label="Zip"
                                                                        TextChanged={(e) => {
                                                                            this.setState({ CoBorrowerPreviousZip: e });
                                                                        }}
                                                                        Value={this.state.CoBorrowerPreviousZip ?? ""}
                                                                        Style={{ width: '5vw' }}
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td align="left" valign="bottom">
                                                                    <TextInput
                                                                        Type="number"
                                                                        Label="# Years"
                                                                        min={1}
                                                                        max={99}
                                                                        MaxTextLength={2}
                                                                        TextChanged={(e) => {
                                                                            this.setState({ CoBorrowerPreviousYears: e });
                                                                        }}
                                                                        Value={this.state.CoBorrowerPreviousYears ?? ""}
                                                                        Style={{ width: '5vw' }}
                                                                    />
                                                                </td>
                                                                <td>
                                                                </td>
                                                                <td>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table>
                        <tbody>
                            <tr>
                                <td align="left">
                                    <table cellPadding={2} cellSpacing={2}>
                                        <tbody>
                                            <tr>
                                                <td align="left" valign="middle">
                                                    Own or Rent?
                                                </td>
                                                <td align="left" valign="middle">
                                                    <div className="radioGroup">
                                                        <input type="radio"
                                                            name="ownRent"
                                                            style={{ marginRight: '5px' }}
                                                            onChange={(e) => {
                                                                this.setState({ CoBorrowerCurrentOwnOrRent: e.target.checked ? "Own" : "Rent" });
                                                            }}
                                                            checked={this.state.CoBorrowerCurrentOwnOrRent === "Own"}
                                                        ></input>
                                                        <label>Own</label>
                                                        <input type="radio"
                                                            name="ownRent"
                                                            style={{ marginRight: '5px' }}
                                                            onChange={(e) => {
                                                                this.setState({ CoBorrowerCurrentOwnOrRent: e.target.checked ? "Rent" : "Own" });
                                                            }}
                                                            checked={this.state.CoBorrowerCurrentOwnOrRent === "Rent"}
                                                        ></input>
                                                        <label>Rent</label>
                                                    </div>
                                                </td>
                                                <td>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td align="left" valign="bottom">
                                    <TextInput
                                        Type="custom"
                                        Label="Monthly Mortgage / Rent"
                                        TextChanged={(e) => {
                                            this.setState({ CoBorrowerCurrentMortgageRent: e });
                                        }}
                                        Value={this.formatCurrency(this.state.CoBorrowerCurrentMortgageRent) ?? ""}
                                        Style={{ width: '11vw' }}
                                    />
                                </td>
                                <td align="left" valign="bottom">
                                </td>
                                <td align="left" valign="bottom">
                                </td>
                            </tr>
                            <tr>
                                <td align="left" style={{ paddingRight: '3vw' }}>
                                    <table cellPadding={2} cellSpacing={2}>
                                        <tbody>
                                            <tr>
                                                <td style={{ fontSize: '15px', fontWeight: '500', paddingTop: '15px' }} align="left">
                                                    Employment
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan={3} align="left" valign="bottom">
                                                    <TextInput
                                                        Type="text"
                                                        Label="Company or Employer Name"
                                                        TextChanged={(e) => {
                                                            this.setState({ CoBorrowerCurrentEmployerName: e });
                                                        }}
                                                        Value={this.state.CoBorrowerCurrentEmployerName ?? ""}
                                                        Style={{ width: '13vw' }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan={3} align="left" valign="bottom">
                                                    <TextInput
                                                        Type="text"
                                                        Label="Type of Business"
                                                        TextChanged={(e) => {
                                                            this.setState({ CoBorrowerCurrentEmployerType: e });
                                                        }}
                                                        Value={this.state.CoBorrowerCurrentEmployerType ?? ""}
                                                        Style={{ width: '13vw' }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan={3} align="left" valign="bottom">
                                                    <TextInput
                                                        Type="text"
                                                        Label="Position"
                                                        TextChanged={(e) => {
                                                            this.setState({ CoBorrowerCurrentEmployerPosition: e });
                                                        }}
                                                        Value={this.state.CoBorrowerCurrentEmployerPosition ?? ""}
                                                        Style={{ width: '13vw' }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan={3} align="left" valign="bottom">
                                                    <TextInput
                                                        Type="number"
                                                        Label="# Years"
                                                        min={1}
                                                        max={99}
                                                        MaxTextLength={2}
                                                        TextChanged={(e) => {
                                                            this.setState({ CoBorrowerCurrentEmployerYears: e });
                                                        }}
                                                        Value={this.state.CoBorrowerCurrentEmployerYears ?? ""}
                                                        Style={{ width: '5vw' }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan={3} align="left" valign="bottom">
                                                    <TextInput
                                                        Type="text"
                                                        Label="Address"
                                                        TextChanged={(e) => {
                                                            this.setState({ CoBorrowerCurrentEmployerAddress: e });
                                                        }}
                                                        Value={this.state.CoBorrowerCurrentEmployerAddress ?? ""}
                                                        Style={{ width: '13.5vw' }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="left" valign="bottom">
                                                    <TextInput
                                                        Type="text"
                                                        Label="City"
                                                        TextChanged={(e) => {
                                                            this.setState({ CoBorrowerCurrentEmployerCity: e });
                                                        }}
                                                        Value={this.state.CoBorrowerCurrentEmployerCity ?? ""}
                                                        Style={{ width: '5vw' }}
                                                    />
                                                </td>
                                                <td align="left" valign="bottom">
                                                    <select
                                                        value={this.state.CoBorrowerCurrentEmployerStateId}
                                                        onChange={(e) => {
                                                            this.setState({ CoBorrowerCurrentEmployerStateId: e.target.value })
                                                        }}
                                                    >
                                                        <option key={0} value={0}>--</option>
                                                        {this.state.states.map((item, idx) =>
                                                            <option key={idx} value={item.id}>{item.name}</option>
                                                        )}
                                                    </select>
                                                </td>
                                                <td align="left" valign="bottom">
                                                    <TextInput
                                                        Type="number"
                                                        MaxTextLength={5}
                                                        Label="Zip"
                                                        TextChanged={(e) => {
                                                            this.setState({ CoBorrowerCurrentEmployerZip: e });
                                                        }}
                                                        Value={this.state.CoBorrowerCurrentEmployerZip ?? ""}
                                                        Style={{ width: '5vw' }}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                                <td align="right" valign="top">
                                    <table cellPadding={2} cellSpacing={2}>
                                        <tbody>
                                            <tr>
                                                <td style={{ fontSize: '15px', fontWeight: '500', paddingTop: '15px' }} align="left">
                                                    Previous Employment
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan={3} align="left" valign="bottom">
                                                    <TextInput
                                                        Type="text"
                                                        Label="Company or Employer Name"
                                                        TextChanged={(e) => {
                                                            this.setState({ CoBorrowerPreviousEmployerName: e });
                                                        }}
                                                        Value={this.state.CoBorrowerPreviousEmployerName ?? ""}
                                                        Style={{ width: '13vw' }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan={3} align="left" valign="bottom">
                                                    <TextInput
                                                        Type="text"
                                                        Label="Type of Business"
                                                        TextChanged={(e) => {
                                                            this.setState({ CoBorrowerPreviousEmployerType: e });
                                                        }}
                                                        Value={this.state.CoBorrowerPreviousEmployerType ?? ""}
                                                        Style={{ width: '13vw' }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan={3} align="left" valign="bottom">
                                                    <TextInput
                                                        Type="text"
                                                        Label="Position"
                                                        TextChanged={(e) => {
                                                            this.setState({ CoBorrowerPreviousEmployerPosition: e });
                                                        }}
                                                        Value={this.state.CoBorrowerPreviousEmployerPosition ?? ""}
                                                        Style={{ width: '13vw' }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan={3} align="left" valign="bottom">
                                                    <TextInput
                                                        Type="number"
                                                        Label="# Years"
                                                        min={1}
                                                        max={99}
                                                        MaxTextLength={2}
                                                        TextChanged={(e) => {
                                                            this.setState({ CoBorrowerPreviousEmployerYears: e });
                                                        }}
                                                        Value={this.state.CoBorrowerPreviousEmployerYears ?? ""}
                                                        Style={{ width: '5vw' }}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table>
                        <tbody>
                            <tr>
                                <td colSpan={6} style={{ fontSize: '15px', fontWeight: '500', paddingTop: '15px' }} align="left">
                                    Annual Income
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <TextInput
                                        Type="custom"
                                        Label="Wages"
                                        TextChanged={(e) => {
                                            this.setState({ CoBorrowerIncomeWages: e }, function () { this.calculateTotal(); });

                                        }}
                                        Value={this.formatCurrency(this.state.CoBorrowerIncomeWages)}
                                        Style={{ width: '6vw' }}
                                    />
                                </td>
                                <td>
                                    <TextInput
                                        Type="custom"
                                        Label="Distributions"
                                        TextChanged={(e) => {
                                            this.setState({ CoBorrowerIncomeDistributions: e }, function () { this.calculateTotal(); });
                                        }}
                                        Value={this.formatCurrency(this.state.CoBorrowerIncomeDistributions)}
                                        Style={{ width: '6vw' }}
                                    />
                                </td>
                                <td>
                                    <TextInput
                                        Type="custom"
                                        Label="Rental Income"
                                        TextChanged={(e) => {
                                            this.setState({ CoBorrowerIncomeRentalIncome: e }, function () { this.calculateTotal(); });
                                        }}
                                        Value={this.formatCurrency(this.state.CoBorrowerIncomeRentalIncome)}
                                        Style={{ width: '6vw' }}
                                    />
                                </td>
                                <td>
                                    <TextInput
                                        Type="custom"
                                        Label="Pension"
                                        TextChanged={(e) => {
                                            this.setState({ CoBorrowerIncomePension: e }, function () { this.calculateTotal(); });
                                        }}
                                        Value={this.formatCurrency(this.state.CoBorrowerIncomePension)}
                                        Style={{ width: '6vw' }}
                                    />
                                </td>
                                <td>
                                    <TextInput
                                        Type="custom"
                                        Label="Other"
                                        TextChanged={(e) => {
                                            this.setState({ CoBorrowerIncomeOther: e }, function () { this.calculateTotal(); });
                                        }}
                                        Value={this.formatCurrency(this.state.CoBorrowerIncomeOther)}
                                        Style={{ width: '6vw' }}
                                    />
                                </td>
                                <td>
                                    <TextInput
                                        Type="custom"
                                        Label="Total"
                                        TextChanged={(e) => {
                                            this.setState({ CoBorrowerIncomeTotal: e }, function () { this.calculateTotal(); });
                                        }}
                                        Value={this.formatCurrency(this.state.CoBorrowerIncomeTotal)}
                                        Style={{ width: '6vw' }}
                                        Disabled={true}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table>
                        <tbody>
                            <tr>
                                <td colSpan={2} align="left" style={{ paddingTop: '15px' }}>
                                    <div style={{ fontSize: '11px', fontWeight: '400', paddingTop: '5px', width: '36.5vw', height: '20vh', overflow: 'auto', border: '1px solid #eee', padding: '5px', backgroundColor: 'aliceblue' }}>
                                        We authorize Fairwind Financial Corporation, its Assigns and/or their Lender(s) to obtain information, including credit inquiries/reports, employment history and any other information necessary to evaluate credit.  The applicant and/or co-applicant may ask whether Fairwind Financial Corporation obtained such a report.  If such a report has been obtained, the applicant and/or the co-applicant may request the name and address of the reporting agency that provided the report. This application shall remain the property of Fairwind Financial Corporation, its Assigns and/or Lender(s), whether or not said credit is granted.<br /><br />
                                        Income derived from alimony, child support or other maintenance payments need not be disclosed when applying for credit.<br /><br />
                                        All the statements We have made are true, correct and complete, We understand you will rely upon their accuracy when determining whether or not said credit is granted.<br /><br />
                                        PATRIOT ACT NOTICE: To help the government fight the funding of terrorism and money laundering activities, Federal Law requires all financial institutions to obtain, verify and record information that identifies each person who opens an account. For purposes of this section, account shall be understood to include loan accounts.<br /><br />
                                        You agree as follows: On each phone number that you provide to us on this application, whether cell phone or landline, you consent to us, our assigns, lenders and agents, of any of us contacting you at the number by calling, texting or any other electronic communication from time to time for any reason about your accounts, including but not limited to, for collection and payment purposes. You agree that automated dialing, equipment or pre-recorded voice message maybe used for any of those purposes.<br /><br />
                                        If this is an application for joint credit with another person, complete all sections of page 2, by providing information in the Co-Borrower section, and by initialing below, you confirm your intent to apply for joint credit.<br /><br />
                                        By completing and submitting this elctronic application, We consent to conduct business electronically with Fairwind Financial Corporation, and that this electroinc communiction will have the same legal capacity as any written and/or sign paper application or communication.  In addition, your signature below confirms your consent to receive all the disclosures noted on the application electronically.  If you wish to receive a paper copy of the Disclosures, you can do so my requesting a copy from <a href="mailto:info@fairwindfinancial.com">info@fairwindfinancial.com</a><br /><br />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ display: 'flex', flexDirection: 'row', width: 'fit-content', alignItems: 'center', justifyContent: 'flex-start' }}>
                                        <input
                                            type="checkbox"
                                            checked={this.state.AcknowledgeDisclosuresAndDigitalSignature ?? false}
                                            onChange={(e) => {
                                                this.setState({ AcknowledgeDisclosuresAndDigitalSignature: !this.state.AcknowledgeDisclosuresAndDigitalSignature })
                                            }}
                                            style={{ marginRight: '5px' }}
                                        />
                                        <label style={{ marginBottom: '0', fontSize: '12px' }}>We acknowledge that We have read the disclosures and will be providing digital signatures when submitting this loan application.</label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <table cellPadding={5} style={{ marginBottom: '10px' }}>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <TextInput
                                                        Type="text"
                                                        Label="Borrower Signature"
                                                        TextChanged={(e) => {
                                                            this.setState({ BorrowerSignature: e });
                                                        }}
                                                        Value={this.state.BorrowerSignature ?? ""}
                                                        Style={{ width: '12vw', fontFamily: 'Imperial Script', fontSize: '18px' }}
                                                    />
                                                </td>
                                                <td>
                                                    <TextInput
                                                        Type="date"
                                                        Label="Date"
                                                        TextChanged={(e) => {
                                                            this.setState({ BorrowerSignatureDate: e });
                                                        }}
                                                        Value={this.state.BorrowerSignatureDate != undefined ? this.sqlToJsDate(this.state.BorrowerSignatureDate) : this.setState({ BorrowerSignatureDate: customFunctions.formatDateOrTimeForInput(new Date().toLocaleDateString('en-US'), 'date') })}
                                                        Style={{ width: '7vw' }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <TextInput
                                                        Type="text"
                                                        Label="Co-Borrower Signature"
                                                        TextChanged={(e) => {
                                                            this.setState({ CoBorrowerSignature: e });
                                                        }}
                                                        Value={this.state.CoBorrowerSignature ?? ""}
                                                        Style={{ width: '12vw', fontFamily: 'Imperial Script', fontSize: '18px' }}
                                                    />
                                                </td>
                                                <td>
                                                    <TextInput
                                                        Type="date"
                                                        Label="Date"
                                                        TextChanged={(e) => {
                                                            this.setState({ CoBorrowerSignatureDate: e });
                                                        }}
                                                        Value={this.state.CoBorrowerSignatureDate != undefined ? this.sqlToJsDate(this.state.CoBorrowerSignatureDate) : this.setState({ CoBorrowerSignatureDate: customFunctions.formatDateOrTimeForInput(new Date().toLocaleDateString('en-US'), 'date') })}
                                                        Style={{ width: '7vw' }}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="footer-center-content">
                    <table style={{ height: '100%' }}>
                        <tbody>
                            <tr>
                                <td align="center" valign="middle">
                                    <button
                                        className="creditAppNext"
                                        style={{ whiteSpace: 'nowrap' }}
                                        disabled={this.state.loading}
                                        onClick={() => {
                                            this.save("/LoanApplicationStep2");
                                        }}
                                    >Back
                                    </button>
                                </td>
                                <td align="center" valign="middle">
                                    <button
                                        className="creditAppNext"
                                        style={{ whiteSpace: 'nowrap' }}
                                        disabled={this.state.loading ? true : false}
                                        onClick={() => {
                                            this.save();
                                        }}
                                        disabled={this.state.loading || !this.state.AcknowledgeDisclosuresAndDigitalSignature}
                                    >
                                        Submit Application
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <Popup
                    headerText={"Important Notice"}
                    bodyText={"Loan requests in excess of $150,000 typically require a completed Personal Financial Statement.  If you do not complete it now, you may be required to completed it prior to receiving a credit decision."}
                    button1Text={"Continue to the Personal Financial Statement"}
                    showButton2={true}
                    button2Text={"Skip Personal Financial Statement and Submit Application"}
                    button1ClickHandler={this.handleButton1Click}
                    button2ClickHandler={this.handleButton2Click}
                    showModal={this.state.showModal}
                />
            </div>
        )
    }

    handleButton1Click() {
        window.location.href = "/ApplicantPersonalFinancialStatement";
    }

    handleButton2Click() {
        window.location.href = "/LoanApplicationReceived";
    }
}